import { Component } from '@angular/core';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

export interface GgCmsLinkComponent {
  uid: string;
  linkName: string;
  url: string;
  locUrl: string;
  styleClasses: string;
}

@Component({
  selector: 'app-gg-cms-link',
  templateUrl: 'gg-cms-link.component.html',
  styleUrls: ['gg-cms-link.component.scss'],
  standalone: false,
})
export class GgCmsLinkComponent {
  data$: Observable<GgCmsLinkComponent> = this.componentData.data$;

  constructor(private componentData: CmsComponentData<GgCmsLinkComponent>) {}

  getTarget(data: CmsLinkComponent): string | null {
    return data.target === 'true' || data.target === true ? '_blank' : null;
  }
}
